"use client";

import Link from "next/link";
import Image from "next/image";
import {
  ShieldCheck,
  Cookie,
  Gavel,
  Handshake,
  Shield,
  FileCog,
  FileCheck2,
} from "lucide-react";
import { usePathname } from "next/navigation";
import { Separator } from "@/components/ui/separator";
import { cn } from "@/lib/utils";
import { useChat } from "@/providers/chat";

export default function LegalLayout({
  children,
}: Readonly<{ children: React.ReactNode }>) {
  const pathname = usePathname();
  const {messages} = useChat();

  return (
    <>
      <header className="flex justify-center py-15">
        <Link href="/" className="flex items-center gap-2 text-xl font-bold">
          <Image src="/images/logo.svg" alt="Logo" width={42} height={42} />
          <span>Telephony Voice AI Agent</span>
        </Link>
      </header>
      <div className="container mx-auto flex flex-col lg:flex-row flex-1 p-4 gap-10 lg:gap-12">
        <aside className="w-full lg:w-1/4 lg:pl-8 lg:sticky top-24 h-fit transition-all duration-300">
          <nav className="flex flex-col space-y-2 bg-blue-50 p-5 rounded-md border-[2px] border-blue-300">
            <Link href="/legal/content-policy"
              className={cn(
                "flex items-center gap-3 hover:text-primary hover:bg-white p-4 rounded-md",
                pathname === "/legal/content-policy"
                  ? "bg-white text-primary"
                  : "text-gray-800"
              )}
            >
              <Shield size={20} />
              User Safety & Content Policy
            </Link>
            <Separator />
            <Link href="/legal/terms-of-use"
              className={cn(
                "flex items-center gap-3 hover:text-primary hover:bg-white p-4 rounded-md",
                pathname === "/legal/terms-of-use"
                  ? "bg-white text-primary"
                  : "text-gray-800"
              )}
            >
              <Gavel size={20} />
              Terms of Use
            </Link>
            <Link href="/legal/services-agreement"
              className={cn(
                "flex items-center gap-3 hover:text-primary hover:bg-white p-4 rounded-md",
                pathname === "/legal/services-agreement"
                  ? "bg-white text-primary"
                  : "text-gray-800"
              )}
            >
              <Handshake size={20} />
              Services Agreement
            </Link>
            <Separator />
            <Link href="/legal/data-processing-addendum"
              className={cn(
                "flex items-center gap-3 hover:text-primary hover:bg-white p-4 rounded-md",
                pathname === "/legal/data-processing-addendum"
                  ? "bg-white text-primary"
                  : "text-gray-800"
              )}
            >
              <FileCog size={20} />
              Data Processing Addendum
            </Link>
            <Link href="/legal/privacy-policy"
              className={cn(
                "flex items-center gap-3 hover:text-primary hover:bg-white p-4 rounded-md",
                pathname === "/legal/privacy-policy"
                  ? "bg-white text-primary"
                  : "text-gray-800"
              )}
            >
              <ShieldCheck size={20} />
              Privacy Policy
            </Link>
            <Link href="/legal/usage-policy"
              className={cn(
                "flex items-center gap-3 hover:text-primary hover:bg-white p-4 rounded-md",
                pathname === "/legal/usage-policy"
                  ? "bg-white text-primary"
                  : "text-gray-800"
              )}
            >
              <FileCheck2 size={20} />
              Usage Policy
            </Link>
            <Link href="/legal/cookie-policy"
              className={cn(
                "flex items-center gap-3 hover:text-primary hover:bg-white p-4 rounded-md",
                pathname === "/legal/cookie-policy"
                  ? "bg-white text-primary"
                  : "text-gray-800"
              )}
            >
              <Cookie size={20} />
              Cookie Policy
            </Link>
          </nav>
        </aside>
        <main className="w-full lg:w-3/4 order-1 lg:order-2 mb-10 p-6 border border-blue-300 bg-white rounded-lg shadow-sm">{children}</main>
      </div>
    </>
  );
}